import React, { useEffect, useState } from "react";

const FormField = ({
  label,
  id,
  type,
  icon,
  disabled = false,
  handleChange,
}) => {
  const defaultHandleChange = (e) => {
    if (handleChange) {
      handleChange(e);
    }
    setValue(e.target.value);
  };
  const [value, setValue] = useState("");
  useEffect(() => {
    localStorage.setItem(id, JSON.stringify(value));
  }, [value]);

  return (
    <div className="form-floating" style={{ marginTop: 10 }}>
      <input
        type={type}
        className="form-control"
        id={id}
        disabled={disabled}
        placeholder={label}
        value={value}
        onChange={defaultHandleChange}
      />
      <label htmlFor={id}>
        <i className={icon}></i> {label}
      </label>
    </div>
  );
};

export default FormField;
